import template from './price-currency-text.jade';
import currency from '../../../../enums/currency';
import validation from '../../../../services/validation';
import { selectAnalyticsOfferStatus } from '../../../../../../../shared/selectors/analytics';
import { trackRequiredFieldFillByName } from '../../../../../../../shared/utils/tracking/requiredFields';

export default angular.module('cian.addForm.helperPriceCurrencyText', []).directive('cianAfHelperPriceCurrencyText', [
  '$sce',
  $sce => ({
    scope: {},
    transclude: true,
    bindToController: {
      ad: '=',
      form: '=',
      inputName: '@',
      inputModel: '=',
      priceLimit: '@?',
      isRequired: '=?',
      validationMessages: '=?',
      maxLength: '@?',
      fieldName: '@',
    },
    controller: [
      '$scope',
      'deviceService',
      'store',
      function ($scope, deviceService, store) {
        this.isMobile = deviceService.isMobile;
        if (!this.ad.bargainTerms) {
          this.ad.bargainTerms = {};
        }

        this.isRequired = angular.isDefined(this.isRequired) ? this.isRequired : true;

        $scope.$watch('priceCurrencyText.ad.bargainTerms.currency', newValue => {
          if (!newValue) {
            return;
          }

          const currencyValue = currency.find(item => {
            return item.key === newValue;
          })?.name;

          this.currency = $sce.trustAsHtml(currencyValue);
        });

        this.valueMin = 0;
        this.valueMax = 10e9;
        const valueMaxLength = String(this.valueMax).length - 1;

        let priceValidationMessages = {
          parse: 'Введите число',
          min: 'Цена не может быть отрицательной',
          max: `Допустимо не более ${valueMaxLength} символов`,
          maxlength: `Допустимо не более ${valueMaxLength} символов`,
          required: `Не указана ${this.fieldName || 'стоимость'}`,
        };

        // Число выбрано исходя из сообщений выше
        const MAX_VALIDATION_MESSAGE_LENGTH_FOR_TOOLTIP = 50;

        this.shouldTooltipOpen = () => this.validation.message().length <= MAX_VALIDATION_MESSAGE_LENGTH_FOR_TOOLTIP;

        if (angular.isDefined(this.validationMessages)) {
          priceValidationMessages = {
            ...priceValidationMessages,
            ...this.validationMessages,
          };
        }

        this.validation = validation(this.form, this.inputName, priceValidationMessages);

        this.maxLength = this.maxlength || 10;

        let trackedValues = {};

        this.handleBlur = () => {
          const value = this.inputModel;
          const trackedValue = trackedValues[this.inputName];

          if (value && value !== trackedValue) {
            const state = store.getState();
            const category = selectAnalyticsOfferStatus(state);

            trackRequiredFieldFillByName(category, this.inputName);
            trackedValues[this.inputName] = value;
          }
        };

        $scope.$watch('priceCurrencyText.ad.bargainTerms.currency', newValue => {
          const currencyValue = currency.find(item => {
            return item.key === newValue;
          })?.name;

          this.currency = $sce.trustAsHtml(currencyValue);
        });
      },
    ],
    controllerAs: 'priceCurrencyText',
    template,
  }),
]).name;
